import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { HttpDataService, IResponseWrapper } from "./httpdata.service";
import { environment } from "src/environments/environment";
import { MarketFilterModel } from "@models/map/market-filter.model";

@Injectable({
    providedIn: "root",
})
export class ReportsService {
    private readonly http = inject(HttpDataService);

    priceStatisticsReportUrl = `${environment.apiUrl}/Report/PriceStatisticsReportV2`;
    weeklyTrendReportUrl = `${environment.apiUrl}/Report/CreateTrendReportSubscription`;

    getPriceStatisticReportUrl = (payload: any): Observable<any> => {
        return this.http.post<IResponseWrapper<any>>(this.priceStatisticsReportUrl, payload).pipe(map((res) => res.data));
    };

      createAndSubscribe(emails: string[], title: string, dayOfPeriod: number, filters: MarketFilterModel) {    
        const additionalFilters = {
            ...filters,
            includeUnCertainPrices: true, // Have to set this to always true due to legacy trend report behaviour.
            name: title,
            filterType: FilterType.WeeklyTrendReport,
            areas: filters.areas,
            geoBorder: filters.geoBorder
        }

        return this.http.post<IResponseWrapper<any>>(this.weeklyTrendReportUrl, { emails, title, dayOfPeriod, filters: additionalFilters }).pipe(map((res) => res.data));        
    }
}


export enum FilterType {
    Market = 10,
    Properties = 20,
    NewDwelling = 30,
    Commercial = 40,
    WeeklyTrendReport = 50
}
